<template>
  <p
    class="ai-persistent-disclosure"
    :class="{ 'ai-persistent-disclosure--above-input': placement === 'above-input' }"
    data-cy="ai-persistent-disclosure"
  >
    {{ PERSISTENT_AI_DISCLOSURE }}
  </p>
</template>

<style scoped>
.ai-persistent-disclosure {
  margin: 0 0 12px;
  font-size: 12px;
  line-height: 1.4;
  color: var(--kate-type-alt);
}

.ai-persistent-disclosure--above-input {
  margin: 0 12px 6px;
  text-align: center;
  font-size: 11px;
  line-height: 1.35;
}
</style>

<style>
[data-theme="dark"] .ai-persistent-disclosure,
[data-theme="legacy"] .ai-persistent-disclosure {
  color: var(--kate-warning) !important;
}

[data-theme="light"] .ai-persistent-disclosure {
  color: var(--kate-type-secondary) !important;
}
</style>

<script>
import { PERSISTENT_AI_DISCLOSURE } from '@constants/ai-disclosure-copy';

export default {
  name: 'KAiPersistentDisclosure',
  props: {
    placement: {
      type: String,
      default: 'default',
      validator: value => ['default', 'above-input'].includes(value),
    },
  },
  data() {
    return {
      PERSISTENT_AI_DISCLOSURE,
    };
  },
};
</script>
